import GlobalSearchContainer from './components/GlobalSearchContainer';

export default GlobalSearchContainer;
